import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as ReferralsActions from './referrals.actions';
import * as ReferralsSelectors from './referrals.selectors';
import { ReferralRequestParams } from '@fantaz/shared/data-access/models';

@Injectable()
export class ReferralsFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(ReferralsSelectors.getReferralsLoaded));
  allReferrals$ = this.store.pipe(select(ReferralsSelectors.getAllReferrals));
  selectedReferrals$ = this.store.pipe(select(ReferralsSelectors.getSelected));
  totalCommission$ = this.store.pipe(
    select(ReferralsSelectors.getTotalCommissionReferrals),
  );
  pagination$ = this.store.pipe(
    select(ReferralsSelectors.getReferralsPagination),
  );
  total$ = this.store.pipe(select(ReferralsSelectors.getTotal));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(options: ReferralRequestParams) {
    this.store.dispatch(ReferralsActions.init({ options }));
  }

  refetch() {
    this.store.dispatch(ReferralsActions.refetch());
  }
}
